import React from 'react';
import { Link } from 'react-router-dom';
import ListingCard from '../components/ListingCard';
import ListingDetail from '../components/ListingDetail';
import { useListings } from '../hooks/useFirestore';

const WA_DEFAULT = 'https://wa.me/971585338786?text=Hi%20I%20am%20interested%20in%20buying%20or%20selling%20an%20e-bike';

export default function Home() {
  const { listings, loading } = useListings({ status: 'Listed' });
  const [selected, setSelected] = React.useState(null);
  const featured = listings.slice(0, 3);

  return (
    <div className="fade-in">
      {/* Hero */}
      <section style={{ padding: '80px 20px', textAlign: 'center', position: 'relative', overflow: 'hidden' }}>
        <div style={{ position: 'absolute', inset: 0, background: 'radial-gradient(ellipse at 50% 0%, rgba(0,229,160,0.08) 0%, transparent 60%)' }} />
        <div style={{ position: 'relative', maxWidth: 700, margin: '0 auto' }}>
          <div className="badge" style={{ background: 'var(--volt)', color: 'var(--dark)', marginBottom: 24, fontSize: 12 }}>Dubai's #1 E-Bike Marketplace</div>
          <h1 style={{ fontSize: 'clamp(32px, 6vw, 56px)', fontWeight: 700, lineHeight: 1.1, marginBottom: 16 }}>
            Buy · Sell · Trade<br /><span style={{ color: 'var(--volt)' }}>Electric Bikes</span>
          </h1>
          <p style={{ color: 'var(--text-2)', fontSize: 18, marginBottom: 40, maxWidth: 500, margin: '0 auto 40px' }}>
            Surron, Talaria, Kugoo & electric scooters. The trusted marketplace for e-bike enthusiasts in Dubai.
          </p>
          <div style={{ display: 'flex', gap: 16, justifyContent: 'center', flexWrap: 'wrap' }}>
            <Link to="/buy" style={{ textDecoration: 'none' }}>
              <button className="btn-volt" style={{ padding: '16px 32px', fontSize: 16 }}>🛒 Buy an E-Bike</button>
            </Link>
            <Link to="/sell" style={{ textDecoration: 'none' }}>
              <button className="btn-outline" style={{ padding: '16px 32px', fontSize: 16 }}>💰 Sell Your E-Bike</button>
            </Link>
            <a href={WA_DEFAULT} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
              <button className="btn-wa" style={{ padding: '16px 32px', fontSize: 16 }}>💬 WhatsApp Us</button>
            </a>
          </div>
        </div>
      </section>

      {/* Brands */}
      <section style={{ padding: '40px 20px 60px', maxWidth: 1200, margin: '0 auto' }}>
        <h2 style={{ textAlign: 'center', fontSize: 13, color: 'var(--text-3)', textTransform: 'uppercase', letterSpacing: 2, marginBottom: 24 }}>Trusted Brands</h2>
        <div style={{ display: 'flex', justifyContent: 'center', gap: 16, flexWrap: 'wrap' }}>
          {[
            { name: 'Surron', to: '/surron-dubai' },
            { name: 'Talaria', to: '/talaria-dubai' },
            { name: 'Kugoo', to: '/electric-scooters-dubai' },
          ].map(b => (
            <Link key={b.name} to={b.to} style={{ textDecoration: 'none' }}>
              <div style={{ background: 'var(--dark-3)', border: '1px solid var(--dark-4)', borderRadius: 12, padding: '16px 32px', color: 'var(--text)', fontFamily: "'Space Grotesk'", fontWeight: 600, fontSize: 15, transition: 'all 0.2s', cursor: 'pointer' }}>{b.name}</div>
            </Link>
          ))}
        </div>
      </section>

      {/* Featured Listings */}
      {!loading && featured.length > 0 && (
        <section style={{ padding: '40px 20px 80px', maxWidth: 1200, margin: '0 auto' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
            <h2 style={{ fontSize: 24 }}>Featured Bikes</h2>
            <Link to="/buy" style={{ textDecoration: 'none' }}><button className="btn-outline btn-sm">View All →</button></Link>
          </div>
          <div className="grid-3">
            {featured.map(l => <ListingCard key={l.id} listing={l} onClick={setSelected} />)}
          </div>
        </section>
      )}

      {/* How it works */}
      <section style={{ padding: '60px 20px', background: 'var(--dark-2)' }}>
        <div style={{ maxWidth: 1200, margin: '0 auto' }}>
          <h2 style={{ textAlign: 'center', fontSize: 24, marginBottom: 40 }}>How It Works</h2>
          <div className="grid-3">
            {[
              { emoji: '🔍', title: 'Browse', desc: 'Explore our curated collection of verified e-bikes' },
              { emoji: '💬', title: 'Connect', desc: 'WhatsApp us to ask questions, reserve, or schedule a test ride' },
              { emoji: '⚡', title: 'Ride', desc: 'Meet up, inspect the bike, and hit the road' },
            ].map((s, i) => (
              <div key={i} style={{ textAlign: 'center', padding: 32 }}>
                <div style={{ fontSize: 40, marginBottom: 16 }}>{s.emoji}</div>
                <h3 style={{ fontSize: 16, marginBottom: 8 }}>{s.title}</h3>
                <p style={{ color: 'var(--text-2)', fontSize: 14 }}>{s.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {selected && <ListingDetail listing={selected} onClose={() => setSelected(null)} />}
    </div>
  );
}
